/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { shape } from 'prop-types';
import { Icon } from 'semantic-ui-react';
import Linkify from 'react-linkify';

import styles from './MessageItem.less';

const MessageText = props => {
  const { body, source, message } = props;
  const [isOpenSource, setOpenSource] = useState(false);
  const nameIcon = isOpenSource ? 'angle up' : 'angle down';
  const isHtml = body?.slice(0, 6) === '<body>';
  return (
    <div className="content-text" id={`message_${message?.id}`}>
      <span>
        {isHtml ? (
          <div
            className={styles.wrapHtml}
            dangerouslySetInnerHTML={{
              __html: body,
            }}
          />
        ) : (
          <Linkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
              <a
                style={{ textDecoration: 'underline' }}
                target="_blank"
                href={decoratedHref}
                key={key}
                rel="noreferrer">
                {decoratedText}
              </a>
            )}>
            {body}
          </Linkify>
        )}
      </span>
      {source && (
        <div className={styles.source}>
          <div className={styles.iconSource}>
            <Icon
              className={styles.icon}
              size="large"
              name={nameIcon}
              onClick={() => setOpenSource(!isOpenSource)}
            />
          </div>
          {isOpenSource && <div className={styles.sourceText}>{source.extraText}</div>}
        </div>
      )}
    </div>
  );
};

MessageText.propTypes = {
  source: shape({}),
};
MessageText.defaultProps = {
  source: null,
};

export default MessageText;
